import request from '@/utils/request';
export function doPostRequest(url, data) {
  return request({
    url: url,
    method: 'POST',
    data: data
  });
}
export function doGetRequest(url, params) {
  return request({
    url: url,
    method: 'Get',
    params: params
  });
}